import * as Autolinker from 'autolinker';
import { MediaType, MediaDocument } from '../../media-document.model';
import { ICONOCLAST_URL } from '../content-document-adapter.config';

export class ContentDocumentFacebookAdapter {
    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);
        let author = document.authors && document.authors[0] ? document.authors[0] : {};

        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.body = Autolinker.link(document.matchSentence || document.tagContextMatchSentence || document.body);
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.keywords = document.keywords || document.tagContextKeywords;
        contentDocument.mediaType = MediaType.Facebook;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarRounded = true;
        contentDocument.sourceAvatarImgUrl = author.authorInfo && author.authorInfo.externalId ? `${ICONOCLAST_URL}/zuckicon?userId=${author.authorInfo.externalId}` : '';
        contentDocument.sourceAvatarLinkUrl = author.url;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = author.name;
        contentDocument.sourceNameUrl = author.url;
        contentDocument.tags = document.tags;
        contentDocument.language = document.language;
        contentDocument.mediaImageUrl = (document.images && document.images[0]) ? document.images[0].link : '';

        // TODO: not sure if we need this, might be same as sourceUrl
        contentDocument.url = document.redirectUrl || document.url || document.sourceUrl;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.reachCount = document.reach;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-facebook.adapter.ts